import React from "react";
import classes from "./LabeledInput.module.css";
import Labeled from "../Labeled";

type LabeledInputProps = {
    inputType: string;
    label: string;
    id: string;
    small?: string;
    placeholder?: string;
    value?: string;
    change?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    autofocus?: boolean;
    isValid?: boolean;
};

const LabeledInput: React.FC<LabeledInputProps> = (props) => {
    return (
        <Labeled label={props.label} id={props.id} small={props.small}>
            <input
                className={[
                    classes.LabeledInput,
                    props.isValid || props.isValid === undefined ? "" : classes.invalid
                ].join(" ")}
                id={props.id}
                type={props.inputType}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.change}
                autoFocus={props.autofocus}
            />
        </Labeled>
    );
};

export default LabeledInput;
